import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILeaseEvent, ILeaseFullEvent } from '@api'
import { contractEventFragment } from '@api/fragments'
import { omit } from 'lodash'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateContractEvent: { contractEvent: ILeaseFullEvent }
}

const mutateHandler = handleFetchResult<IPayload, ILeaseFullEvent>({
  handler: (data) => data.updateContractEvent.contractEvent,
  name: 'Contract',
})

export default function update(event: ILeaseEvent) {
  return client.gql
    .mutate({
      mutation: updateMutation,
      variables: {
        input: {
          amount: event.amount.toString(),
          ...omit(event, 'amount', 'createdAt', 'createdBy', 'files', '__typename'),
        },
      },
    })
    .then(mutateHandler)
}

const updateMutation = gql`
  mutation updateContractEvent($input: UpdateContractEventInput!) {
    updateContractEvent(input: $input) {
      contractEvent {
        ...ContractEventFragment
      }
    }
  }
  ${contractEventFragment}
`
